import axios from "axios";

export const getAllDataAsset = async () => {
  return await axios.get(`${window._HOST}admin/assets/`, {
    withCredentials: true,
  });
};

export const getAllDetailDataAsset = async () => {
  return await axios.get(`${window._HOST}admin/assets/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTableAsset = async (
  searchText = null,
  offset = 0,
  limit = 0,
  $sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/assets/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/assets/dataTable?offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertDataAsset = async (formData) => {
  return await axios.post(`${window._HOST}admin/assets`, formData, {
    withCredentials: true,
  });
};

export const updateDataAsset = async (formData, id) => {
  return await axios.post(`${window._HOST}admin/assets/${id}`, formData, {
    withCredentials: true,
  });
};

export const deleteDataAsset = async (id) => {
  return await axios.delete(`${window._HOST}admin/assets/${id}`, {
    withCredentials: true,
  });
};
